// src/router/index.js

import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import SignUp from '@/views/SignUp'
import ChangePassword from '@/views/ChangePassword'
import ModifyProfile from '@/views/ModifyProfile'
import FindPassword from '@/views/FindPassword'
import Lesson from '@/views/Lesson'
import Booking from '@/views/Booking'
import Coupon from '@/views/Coupon'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      component: Lesson
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/signup',
      component: SignUp
    },
    {
      path: '/change',
      component: ChangePassword
    },
    {
      path: '/modify',
      component: ModifyProfile
    },
    {
      path: '/password',
      component: FindPassword
    },
    {
      path: '/booking',
      component: Booking
    },
    {
      path: '/coupon',
      component: Coupon
    }
  ]
})

// end of index.js